import {getInfoFromLocalStorage} from "../../../../actions";
import moment from "moment";

export const config = {
    "name": "发布稿件",
    "key": "publishManuscript",
    "nav": [
        {
            "name": "单位",
            "tabKey": "0",
            "request": {
                "url": "/cm-sites-storage-statistics/manuscript/mediaPublishList",
                "method": "post",
                "params": {
                    // 排序字段
                    // order: "",
                    // 排序方式
                    // direction: -1,
                    startTime: 0,
                    endTime: 0,
                    pageSize: 10,
                    pageNum: 1,
                    authorDeptId:"",
                    authorName:"",
                    deptIds:"",
                    mediaIds:"",

                },
                "defaultParams": {
                    // 检索字段
                    name: "",
                    // 排序字段
                    // order: "",
                    // 排序方式
                    // direction: -1,
                    startTime: 0,
                    endTime: 0,
                    pageSize: 10,
                    pageNum: 1,
                    authorDeptId:"",
                    authorName:"",
                    deptIds:"",
                    mediaIds:"",
                },
                paramsConfig: {
                    size: "pageSize",
                    page: "pageNum",
                    sort: {
                        field: "order",
                        order: {
                            key: "direction",
                            select: {"ascend": 1, "descend": -1}
                        },
                    },
                },
                resConfig: {
                    count: "count",
                    data: "data"
                },
            },
            "renderSearch": {
                "searchConfig": [
                    [
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_selectLinkage",
                                "config": {
                                    "style": {
                                        width: 224,
                                        marginRight:24
                                    },
                                    maxTagCount:1,
                                    defaultValue: "thisDept",
                                    "configMedia": {
                                        "style": {
                                            width: 224,
                                        },
                                        "placeholder": "全部媒体",
                                        "disabled": false,
                                        "id": "sta_media",
                                        "size": "default",
                                        "labelCode": "mediaIds",
                                        "labelName": "请选择所属单位",
                                        "defaultValue":"",
                                        "regStr": "",
                                        "regMsg": "",
                                        maxTagCount:1,
                                    }
                                },
                            },
                            "placeholder": "请选择所属单位",
                            "disabled": false,
                            "id": "sta_dept",
                            "size": "default",
                            "labelCode":  ["deptIds","mediaIds"],
                            "labelName": "请选择所属单位",
                            "defaultValue": [null, null],
                            "regStr": "",
                            "regMsg": ""
                        },
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_selectTreeDeptById",
                                "config": {
                                    style: {
                                        width: 224
                                    },
                                    searchPlaceholder: '请输入搜索关键词',
                                    treeId: "0",
                                    deleteRootNode: true,
                                    formatConfig: {
                                        title: "name",
                                        key: "id",
                                        value: "id",
                                        children: "child",
                                    },
                                    maxTagCount:1,
                                }
                            },
                            "placeholder": "请选择创建单位",
                            "disabled": false,
                            "id": "sta_dept",
                            "size": "default",
                            "labelCode": "authorDeptId",
                            "labelName": "请选择创建单位",
                            "defaultValue":"",
                            "regStr": "",
                            "regMsg": ""
                        },
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Input",
                                "config": {
                                    style: {
                                        width: 224
                                    }
                                }
                            },
                            "placeholder": "请输入创建人姓名",
                            "disabled": false,
                            "id": "sta_name",
                            "size": "default",
                            "labelCode": "authorName",
                            "labelName": "请输入创建人姓名",
                            "defaultValue":"",
                            "regStr": "",
                            "regMsg": ""
                        },
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Button",
                                "config": {
                                    btnName: "查询",
                                    type: "primary",
                                    clickCall: "onSearch",
                                    style: {
                                        width: 64
                                    }
                                }
                            },
                            "disabled": false,
                            "id": "sta_searchBtn",
                            "size": "default",
                            "labelCode": "",
                        },
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Button",
                                "config": {
                                    btnName: "重置",
                                    type: "default",
                                    clickCall: "onReset",
                                    noRestKey: ["startTime", "endTime"],
                                    style: {
                                        width: 64
                                    }
                                }
                            },
                            "disabled": false,
                            "id": "sta_searchBtn",
                            "size": "default",
                            "labelCode": "",
                        }
                    ],
                    [
                        {
                            "style": {
                                "float": "left",
                            },
                            "component": {
                                "name": "sta_Button",
                                "config": {
                                    btnName: "导出",
                                    type: "default",
                                    clickCall: "onExport",
                                    "request": {
                                        "url": "/cm-sites-storage-statistics/manuscript/export/mediaPublishList",
                                        "method": "downloadPost",
                                        "params": {
                                            // busName: "busNewsClue",
                                            pageSize: 9999
                                        },
                                    },
                                    style: {
                                        width: 64
                                    }
                                }
                            },
                            "disabled": false,
                            "id": "sta_searchBtn",
                            "size": "default",
                            "labelCode": "",
                        },
                        {
                            "style": {
                                "float": "right",
                                marginLeft: 'auto'
                            },
                            "component": {
                                "name": "sta_Date",
                                "config": {
                                    selectDateConfig: {
                                        defaultKey: "thisMonth",
                                        selectConfig: ["today", "yesterday", "thisWeek", "lastWeek", "thisMonth", "lastMonth"]
                                    },
                                    onChangeCallFun: "onSearch",
                                    style: {
                                        width: 768
                                    }
                                }
                            },
                            "value:": "this.state.params.name",
                            "placeholder": "自定义日期范围",
                            "disabled": false,
                            "id": "sta_name",
                            "size": "default",
                            "labelCode": ["startTime", "endTime"],
                            "defaultValue": [null, null],
                            "labelName": "",
                            "regStr": "",
                            "regMsg": ""
                        },
                    ]
                ]
            },
            "renderTable": {
                "defaultItemWidth": 200,
                "columns": [
                    {
                        title: '稿件名称',
                        dataIndex: 'title',
                        "width": 320,
                        ellipsis: true,
                        fixed: 'left',
                        render: '${this.renderView}',
                    },
                    {
                        title: '文字数',
                        "width": 80,
                        dataIndex: 'wordCount',
                        ellipsis: true,
                    },
                    {
                        title: '图片数',
                        "width": 80,
                        dataIndex: 'pictureCount',
                        ellipsis: true,
                    },
                    {
                        title: '创建人',
                        dataIndex: 'authorName',
                        ellipsis: true,
                    },
                    {
                        "title": '创建人所在单位',
                        "dataIndex": 'authorDeptName',
                        ellipsis: true,
                    },
                    {
                        title: '稿件渠道',
                        "width": 100,
                        dataIndex: 'source',
                        ellipsis: true,
                    },
                    {
                        "title": '发布媒体',
                        "dataIndex": 'mediaName',
                        ellipsis: true,
                    },
                    {
                        "title": '媒体所属单位',
                        "dataIndex": 'mediaDeptName',
                        ellipsis: true,
                    },
                    {
                        "title": '发布时间',
                        "dataIndex": 'publishTime',
                        ellipsis: true,
                        render:(text)=>{
                            return moment(text).format('YYYY-MM-DD HH:mm:ss')
                        }
                    },
                    // 隐藏显示创建时间，产品已确认
                    // {
                    //     "title": '创建时间',
                    //     "dataIndex": 'manuscriptCreateTime',
                    //     ellipsis: true,
                    //     render:(text)=>{
                    //         return moment(text).format('YYYY-MM-DD HH:mm:ss')
                    //     }
                    // },
                ]
            },
            "renderPage": {
                size: "middle",
                pageSizeOptions: ['10', '20', '30', '40']
            }
        },
    ]
};